import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=4553fc18&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=ts"
export * from "./AddUser.vue?vue&type=script&lang=ts"
import style0 from "./AddUser.vue?vue&type=style&index=0&id=4553fc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553fc18",
  null
  
)

export default component.exports